// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Gqt_g","comment":"styles_comment__3FZp5"};